import styles from './Content.module.scss';
import { Button, Icon, Text } from 'components';
import { Credentials } from 'services/userService';

type Props = {
  credentials: Credentials;
  generateCredentials(): void;
};

export const Content = ({ credentials, generateCredentials }: Props) => {
  const copyText = (text: string) => navigator.clipboard.writeText(text);
  const credsExist = !!credentials.clientId && !!credentials.clientSecret;

  return (
    <>
      <div className={styles.content}>
        {credsExist && (
          <>
            <div className={styles.contentItem}>
              <Text type="body-big">ClientId:</Text>
              <div className={styles.field}>
                <Text type="body2">{credentials.clientId}</Text>
                <button className={styles.copyButton} onClick={() => copyText(credentials.clientId)}>
                  <Icon name="Files" />
                </button>
              </div>
            </div>
            <div className={styles.contentItem}>
              <Text type="body-big">Secret:</Text>
              <div className={styles.field}>
                <Text type="body2">{credentials.clientSecret}</Text>
                <button className={styles.copyButton} onClick={() => copyText(credentials.clientSecret)}>
                  <Icon name="Files" />
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      <div className={styles.buttonRow}>
        <Button onClick={generateCredentials}>{credsExist ? 'Regenerate' : 'Generate'}</Button>
      </div>
    </>
  );
};
